import { render, staticRenderFns } from "./paymentApproval.vue?vue&type=template&id=3dd01d34&scoped=true&"
import script from "./paymentApproval.vue?vue&type=script&lang=js&"
export * from "./paymentApproval.vue?vue&type=script&lang=js&"
import style0 from "./paymentApproval.vue?vue&type=style&index=0&id=3dd01d34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd01d34",
  null
  
)

export default component.exports